// components/ChatInput.tsx
import React, { useState, useRef } from 'react';
import { useClipShare } from '../hooks/useClipShare';
import { useLanguage } from '../context/LanguageContext';

export const ChatInput: React.FC = () => {
  const { sendMessage, chatMode } = useClipShare();
  const { t } = useLanguage();
  const [message, setMessage] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      sendMessage(message);
      setMessage('');
      inputRef.current?.focus();
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  if (chatMode !== 'manual') {
    return null;
  }

  return (
    <div className="chat-input-container">
      <form onSubmit={handleSubmit} className="chat-input-form">
        <input
          ref={inputRef}
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={t.typeMessage}
          className="chat-input"
          maxLength={1000}
        />
        <button 
          type="submit" 
          className="btn btn-primary chat-send-btn"
          disabled={!message.trim()}
        >
          {t.send}
        </button>
      </form>
    </div>
  );
};
